<template>
  <v-dialog :value="open" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ $t('producto.modals.createOferta.title') }}
      </v-card-title>
      <v-card-text>
        <p>{{ $t('producto.modals.createOferta.message', { count: selectedProductos.length }) }}</p>
        <v-list v-if="selectedProductos.length > 0">
          <v-list-item v-for="(producto, index) in selectedProductos.slice(0, 5)" :key="index">
            <v-list-item-content>
              <v-list-item-title>
                {{ getProductoLabel(producto) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="selectedProductos.length > 5">
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                ... y {{ selectedProductos.length - 5 }} más
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn color="primary" @click="confirm">
          {{ $t('common.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProductoCreateOfertaModal",
  props: {
    open: { type: Boolean, default: false },
    selectedProductos: { type: Array, default: () => [] },
  },
  methods: {
    confirm() {
      const productosIds = this.selectedProductos.map((p) => p.id || p);
      this.$router.push({
        path: '/oferta-management',
        query: { productos: productosIds.join(',') }
      });
      this.$emit('close');
    },
    getProductoLabel(producto) {
      if (typeof producto === 'string') {
        return producto;
      }
      const nombre = producto.marca?.nombre || '';
      const modelo = producto.modelo?.nombre || '';
      return `${nombre} ${modelo}`.trim() || producto.nombre || producto.id;
    },
  },
};
</script>

<style scoped></style>

